$(document).ready(function () {


    document.querySelectorAll('[data-slider-config]').forEach(slider => {
      const config = JSON.parse(slider.dataset.sliderConfig);

      if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick(config);
      }
    });

});

 $(document).on("click", ".el-play-button", function (e) {
     var video = jQuery(this).parents('.el-video-wrapper').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.el-video-wrapper').removeClass('active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.el-video-wrapper').addClass('active');
     jQuery(this).addClass('active');
 }
 });




jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

$(window).on('scroll', function () {
  let scrollTop = $(this).scrollTop();

  if (scrollTop > 30) {
    $('body').addClass('remove_transparent');
  } else {
    $('body').removeClass('remove_transparent');
  }
});



$(document).on("click", ".el-question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.el-question').removeClass('active');
    jQuery('.el-question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});


$(document).on("click", "a[href='/#faq']", function (e) {
  const target = document.querySelector('.el-faq');

  if (target) {
    e.preventDefault();
    target.scrollIntoView({
      behavior: 'smooth'
    });
  }
  // else: do nothing → browser follows the link normally
});
$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.el-pdp-pdt-heading2').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", ".el-mobile-menu-button", function (e) {
    $('.el-drawer-menu').addClass('active');
    $('.el-drawer-menu-bg').show();
    $('body').addClass('el-overflow-hidden');
});
$(document).on("click", ".el-mobile-menu-close", function (e) {
    $('.el-drawer-menu').removeClass('active');
    $('.el-drawer-menu-bg').hide();
    $('body').removeClass('el-overflow-hidden');
});

$(document).on("click", ".el-drawer-menu-bg", function (e) {
    $('.el-drawer-menu').removeClass('active');
    $('.el-drawer-menu-bg').hide();
    $('body').removeClass('el-overflow-hidden');
});




$(document).on("click", ".el-element-option", function(e) {
$(this).parents('.el-product').find('.el-element-option').removeClass('el-active');
$(this).addClass('el-active');
var data_tab = $(this).attr('data_tab');
$(this).parents('.el-product').find('.el-quantity-data').hide();
$(this).parents('.el-product').find('.el-quantity-data[data_tab="'+data_tab+'"]').show();
});











$(document).on("click", ".el-cart-button", function (e) {
window.upcartOpenCart?.();
});


function getLimit() {
  return window.innerWidth <= 768 ? 3 : 6;
}

$(document).on("click", "a[href='#show']", function (e) {
  e.preventDefault();

  var limit = getLimit();

  $('.el-pdp-review2-list1-item:nth-child(' + limit + ') ~ .el-pdp-review2-list1-item')
    .slideDown();

  $('.el-pdp-review2-reads:has(a[href="#show"])').hide();
  $('.el-pdp-review2-reads:has(a[href="#hide"])').show();
});

$(document).on("click", "a[href='#hide']", function (e) {
  e.preventDefault();

  var limit = getLimit();

  $('.el-pdp-review2-list1-item:nth-child(' + limit + ') ~ .el-pdp-review2-list1-item')
    .slideUp();

  $('.el-pdp-review2-reads:has(a[href="#hide"])').hide();
  $('.el-pdp-review2-reads:has(a[href="#show"])').show();
});



  $(document).on("click", '.el-atc-js:not(.el-sold-out)', function (e) {
  e.preventDefault();
  var $btn = $(this);
  if ($btn.hasClass('el-loading')) return;
  $btn.addClass('el-loading');
  var items = [];
var variant_id = $btn.attr('variant_id');
  var item = {
    id: parseInt(variant_id),
    quantity: 1
  };
  items.push(item);
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify({
      items: items
    }),
    dataType: 'json',
    contentType: 'application/json',

    success: function () {

    },

    complete: function () {
      setTimeout(function () {
        $btn.removeClass('el-loading');
      }, 500);
    }
  });
});











$(function () {

    $('.el-element-variants').each(function () {

        const $wrapper = $(this);

        const variants = JSON.parse(
            $wrapper.find('.el-variants-json').html()
        );

        function getSelectedOptions() {

            let selectedOptions = [];

            const firstOption = $wrapper
                .find('.el-variant-option-item.el-active .el-variant-option-title')
                .attr('value');

            if (firstOption) {
                selectedOptions.push(firstOption);
            }

            $wrapper.find('.el-product-option-select').each(function () {
                selectedOptions.push($(this).val());
            });

            return selectedOptions;
        }

        function updateVariant() {

            const selectedOptions = getSelectedOptions();

            const matchedVariant = variants.find(function (variant) {

                return variant.options.every(function (option, index) {
                    return option == selectedOptions[index];
                });

            });

            if (matchedVariant) {

                $wrapper
                    .find('.el-product-variant-id')
                    .val(matchedVariant.id)
                    .trigger('change');
            }

            updateAvailability();
        }

        function updateAvailability() {

            const currentSelections = getSelectedOptions();

            // First option (swatches)
            $wrapper.find('.el-variant-option-item').each(function () {

                const $item = $(this);

                const value = $item
                    .find('.el-variant-option-title')
                    .attr('value');

                const testSelections = [...currentSelections];
                testSelections[0] = value;

                const available = variants.some(function (variant) {

                    if (!variant.available) {
                        return false;
                    }

                    return variant.options.every(function (option, index) {

                        if (!testSelections[index]) {
                            return true;
                        }

                        return option == testSelections[index];
                    });

                });

                $item
                    .toggleClass('el-disabled', !available);
            });

            // Remaining select options
            $wrapper.find('.el-product-option-select').each(function () {

                const $select = $(this);
                const optionIndex = parseInt($select.data('option-position')) - 1;

                $select.find('option').each(function () {

                    const $option = $(this);
                    const optionValue = $option.val();

                    const testSelections = [...currentSelections];
                    testSelections[optionIndex] = optionValue;

                    const available = variants.some(function (variant) {

                        if (!variant.available) {
                            return false;
                        }

                        return variant.options.every(function (option, index) {

                            if (!testSelections[index]) {
                                return true;
                            }

                            return option == testSelections[index];
                        });

                    });

                    $option.prop('disabled', !available);

                });

            });

        }

        $wrapper.on('click', '.el-variant-option-item', function () {

            if ($(this).hasClass('el-disabled')) {
                return;
            }

            $wrapper
                .find('.el-variant-option-item')
                .removeClass('el-active');

            $(this).addClass('el-active');

            updateVariant();
        });

        $wrapper.on('change', '.el-product-option-select', function () {
            updateVariant();
        });

        updateAvailability();

    });

});







(function () {

    const REQUIRED_PRODUCT_ID = 9414160384225;  // live roadarmor-pants product on this store

    // Every free gift tied to the pants. expectedQty receives the pants
    // quantity in the cart and returns how many of that gift belong there.
    const FREE_GIFTS = [
        {
            // hidden $0 RoadArmor™ Belt
            productId: 9531169407201,           // used to match cart lines
            variantId: 48591395160289,          // cart/add.js requires a VARIANT id
            expectedQty: function (pantsQty) {
                return Math.min(pantsQty, 2);   // 1 pants = 1 belt, 2+ pants = 2 belts
            }
        },
        {
            // hidden $0 EKON Summer Balaclava UPF 50+ (free mask)
            productId: 9670214451425,
            variantId: 48900898128097,
            expectedQty: function (pantsQty) {
                return pantsQty > 0 ? 1 : 0;    // always exactly 1 mask with any pants
            }
        }
    ];

    let syncRunning = false;
    let syncQueued = false;

    async function syncFreeGifts() {

        // skip overlapping runs; the queued flag guarantees one final pass
        if (syncRunning) {
            syncQueued = true;
            return;
        }
        syncRunning = true;

        try {

            const cart = await fetch('/cart.js').then(r => r.json());

            // 1. scan cart
            let requiredQty = 0;
            const giftLines = {};

            cart.items.forEach(item => {

                if (item.product_id === REQUIRED_PRODUCT_ID) {
                    requiredQty += item.quantity;
                }

                FREE_GIFTS.forEach(gift => {
                    if (item.product_id === gift.productId) {
                        giftLines[gift.productId] = item;
                    }
                });
            });

            // 2. bring every gift to its expected quantity
            //    (change.js with quantity 0 removes the line)
            let cartChanged = false;

            for (const gift of FREE_GIFTS) {

                const expectedQty = gift.expectedQty(requiredQty);
                const line = giftLines[gift.productId];

                if (line) {

                    if (line.quantity !== expectedQty) {

                        await fetch('/cart/change.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                id: line.key,
                                quantity: expectedQty
                            })
                        });
                        cartChanged = true;
                    }

                } else if (expectedQty > 0) {

                    await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            id: gift.variantId,
                            quantity: expectedQty
                        })
                    });
                    cartChanged = true;
                }
            }

            if (cartChanged) {
                window.upcartRefreshCart();
            }

            // 3. update cart counter UI
            updateCartCounter(cart);

        } finally {

            syncRunning = false;

            if (syncQueued) {
                syncQueued = false;
                syncFreeGifts();
            }
        }
    }

    // Register with UpCart. upcartSubscribeCartUpdated survives UpCart's own
    // initialization, while a plain upcartOnCartUpdated assignment gets
    // overwritten with a no-op when UpCart's bundle loads after this file.
    function registerGiftSync() {

        if (typeof window.upcartSubscribeCartUpdated === 'function') {
            window.upcartSubscribeCartUpdated(syncFreeGifts);
            return;
        }

        // UpCart not loaded yet: cover the gap, then move to the
        // subscribe API as soon as it appears
        window.upcartOnCartUpdated = syncFreeGifts;

        var tries = 0;
        var timer = setInterval(function () {

            tries++;

            if (typeof window.upcartSubscribeCartUpdated === 'function') {
                clearInterval(timer);
                window.upcartSubscribeCartUpdated(syncFreeGifts);
                return;
            }

            if (tries > 150) {
                clearInterval(timer);
            }
        }, 200);
    }

    registerGiftSync();

})();

function updateCartCounter(cart) {

    const totalQty = cart.items.reduce((sum, item) => {
        return sum + item.quantity;
    }, 0);

    const counter = document.querySelector('.el-cart-count');

    if (!counter) return;

    if (totalQty <= 0) {
        counter.style.display = 'none';
        return;
    }

    counter.style.display = 'inline-flex';
    counter.textContent = totalQty;
}